import { render, staticRenderFns } from "./Electric.vue?vue&type=template&id=a67bd6d0&scoped=true&"
import script from "./Electric.vue?vue&type=script&lang=js&"
export * from "./Electric.vue?vue&type=script&lang=js&"
import style0 from "./Electric.vue?vue&type=style&index=0&id=a67bd6d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67bd6d0",
  null
  
)

export default component.exports